module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/worldpay-4bff5561742c7a4434d2d8c8484ee67a.png";